import { Link, useHistory } from "react-router-dom";
import { useEffect, useCallback, useRef } from "react";
import { tokenDecode } from "../../../utils/helper";
import styles from "./navbar.module.css";
import bars from "../../../icons/MenuBar.png";

const Navbar = (props) => {
    const history = useHistory();
    const logoutExecutedRef = useRef(false);
    const logoutTimerRef = useRef(null);

    const token = sessionStorage.getItem("us_st_d");
    const decoded = tokenDecode();
    const { data } = decoded;
    const { user } = data;

    const logouthandler = useCallback(() => {
        sessionStorage.removeItem("us_st_d");
    }, []);

    const handleLogout = useCallback(() => {
        if (!logoutExecutedRef.current) {
            logoutExecutedRef.current = true;
            logouthandler();
            history.push("/");
        }
    }, [history, logouthandler]);

    useEffect(() => {
        const decodedToken = token && tokenDecode(token);
        const expirationTime = decodedToken?.exp * 1000;

        if (expirationTime) {
            const delay = expirationTime - Date.now();

            // Don't create a timer with a negative delay.
            if (delay > 0) {
                logoutTimerRef.current = setTimeout(handleLogout, delay);
            } else {
                handleLogout();
            }
        } else {
            logouthandler();
        }

        return () => {
            if (logoutTimerRef.current) {
                clearTimeout(logoutTimerRef.current);
            }
        };
    }, [token, handleLogout, logouthandler]);

    return (
        <nav
            className={`navbar navbar-expand navbar-light topbar static-top shadow ${styles.mobile_navbar}`}
        >
            <button
                id="sidebarToggleTop"
                type="button"
                className={`btn btn-link rounded-circle mr-3 ${styles.burgerButton}`}
                onClick={() => props.Showmenu?.()}
            >
                <img src={bars} alt="" style={{ height: "70%" }} />
            </button>

            <ul className="navbar-nav">
                <div className="topbar-divider d-none d-sm-block"></div>

                <li className={`nav-item dropdown no-arrow ${styles.plus}`}>
                    <Link
                        to="#"
                        className="nav-link dropdown-toggle"
                        id="userDropdown"
                        role="button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                        <span className="mr-2 d-none d-lg-inline text-gray-600 small">
                            {user?.name}
                        </span>

                        <img
                            className={`img-profile rounded-circle ${styles.dropdownimg}`}
                            src="/img/undraw_profile.svg"
                            alt="Profile"
                        />

                        <div className={styles.searchOpener}>
                            <i
                                className="fa fa-plus-circle"
                                aria-hidden="true"
                            ></i>
                        </div>
                    </Link>

                    <div
                        className={`dropdown-menu shadow animated--grow-in p-0 w-100 ${styles.dropDownPosition}`}
                        aria-labelledby="userDropdown"
                    >
                        <div className={styles.doropdownnavmenu}>

                            {/* Shop Details */}
                            <Link
                                to="/sellerdetail?tab=shopdetails"
                                className={`dropdown-item ${styles.bottomPadding}`}
                                data-toggle="modal"
                                data-target="#logoutModal"
                            >
                                <i className="fas fa-home fa-sm fa-fw mr-2 text-gray-400"></i>
                                <span>Shop details</span>
                            </Link>

                            <div className="dropdown-divider"></div>

                            {/* Serviceability */}
                            <Link
                                to="/serviceability"
                                className={`dropdown-item ${styles.bottomPadding}`}
                                data-toggle="modal"
                                data-target="#logoutModal"
                            >
                                <i className="fa fa-globe fa-sm fa-fw mr-2 text-gray-400"></i>
                                <span>Serviceability</span>
                            </Link>

                            <div className="dropdown-divider"></div>

                            {/* Update Password */}
                            <Link
                                to="/updatepassword"
                                className={`dropdown-item ${styles.bottomPadding}`}
                                data-toggle="modal"
                                data-target="#logoutModal"
                            >
                                <i className="fas fa-list fa-sm fa-fw mr-2 text-gray-400"></i>
                                <span>Update Password</span>
                            </Link>

                            <div className="dropdown-divider"></div>

                            {/* Logout */}
                            <Link
                                to="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleLogout();
                                }}
                                className={`dropdown-item ${styles.bottomPadding}`}
                                data-toggle="modal"
                                data-target="#logoutModal"
                            >
                                <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                                <span>Logout</span>
                            </Link>

                        </div>
                    </div>
                </li>
            </ul>
        </nav>
    );
};

export default Navbar;